import { render, staticRenderFns } from "./ServiceIntroduction.vue?vue&type=template&id=c95484a4&scoped=true"
import script from "./ServiceIntroduction.vue?vue&type=script&lang=js"
export * from "./ServiceIntroduction.vue?vue&type=script&lang=js"
import style0 from "./ServiceIntroduction.vue?vue&type=style&index=0&id=c95484a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95484a4",
  null
  
)

export default component.exports